"use strict";

class userSettings {

	constructor($http) {
		this.settings = {};
		this.$http = $http;
		this.listeners = [];
		this.loaded = false;
		this.promise = new Promise((resolve) => {
			$http.get('/usersettings').then((response) => {
				this.settings = response.data;
				if (typeof this.settings.showSideBar == 'undefined') {
					this.settings.showSideBar = true;
				}
				if (typeof this.settings.time == 'undefined') {
					this.settings.time = true;
				}
				if (typeof this.settings.checkbox == 'undefined') {
					this.settings.checkbox = true;
				}
				this.callListeners();
				this.loaded = true;
				resolve(this.settings);
			});
		});
	}

	setSetting(type, bool, save = true) {
		this.settings[type] = bool;
		if (save) {
			let settings = {};
			settings[type] = bool;
			this.saveToDatabase(settings);
		}
	}

	setSettings(settings) {
		if (settings !== {}) {
			for (let setting in settings) {
				if (settings.hasOwnProperty(setting)) {
					this.setSetting(setting, settings[setting], false);
				}
			}
			this.saveToDatabase(settings);
		}
	}

	saveToDatabase(settings) {
		this.$http.post('/usersettings', settings).then((response) => {
			for (let setting in response.data) {
				if (response.data.hasOwnProperty(setting)) {
					this[setting] = response.data[setting];
				}
			}
			this.callListeners();
		});
	}

	addListener(callback) {
		this.listeners.push(callback);
		if (this.loaded) {
			callback(this.settings);
		}
	}

	removeListener(callback) {
		const index = this.listeners.indexOf(callback);
		if (index !== -1) this.listeners.splice(index, 1);
	}

	callListeners() {
		for (let listener in this.listeners) {
			if (this.listeners.hasOwnProperty(listener)) {
				this.listeners[listener](this.settings);
			}
		}
	}
}

userSettings.$inject = [
	'$http',
];

module.exports = userSettings;
